import React, {Fragment} from 'react';
import Box from '../../layout/Box';
import StoreOrderForm from './../forms/storeorderForm';
import StoreOrderList from './../lists/storeorderList';
import BoxEditor from "./../BoxEditor";
import Button from "../../form/Button";
import PrintButton from "../../form/PrintButton";
import {postData, sendRequest} from "../../../utils/request";
import {connect} from "src/store";
import createEditor from "../../form/ComponentEditor";
import StoreOrderClaimEditor from "../StoreOrderClaimEditor";
import ModalEditor from "../ModalEditor";
import {
    ComponentFormatter,
    CurrencyFormatter,
    ProductColumn,
    UnitFormatter,
    UpdatedByFormatter,
    UserFormatter
} from "../../../utils/formatters";
import TextInput from "../../form/TextInput";
import {ifCompletedInput, operation} from "../../../utils/other";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import Modal from "../../layout/Modal";
import {showModal} from "../../../actions";
import Portal from "../../layout/Portal";
import Tabs from "../../layout/Tabs";
import TabContent from "../../layout/TabContent";
import PurchaseList from "../lists/purchaseList";
import {stateConst as PurchaseStates} from "../purchaseEditor";
import StockTransferList from "../lists/stocktransferList";
import {stateConst as StockTransferStates} from "../stocktransferEditor";
import ComponentConfig from "../../form/ComponentConfig";
import CheckBox from "../../form/CheckBox";
import {Tooltip} from "react-tippy";
import {UnknownStoreOrderOperationPresets} from "../../../config/config";
import {list} from "../../../utils/array";
import {fieldFilter, loadComponent} from "../../../utils/components";
import ProductPicker from "../OperationList/Elements/Inventory/ProductPicker";
import Confirm from "../../form/Confirm";
import ContentLoader from "../../layout/ContentLoader";
import parse_url from "locutus/php/url/parse_url";
import DetailsButton, {componentEditors} from "../../form/DetailsButton";

export const orderTypes = {
    SALES_ORDER:  ordertype => operation(ordertype, 0),
    PURCHASE_ORDER: ordertype => operation(ordertype, 1),
};

export const stateConst = {
    Received: 0,
    Accepted: 100,
    StockMismatch: 200,
    Reserved: 300, //Kiszedés alatt
    Processed: 400, // eltérésben van, ha beszerzés akkor a qty oszlop szerkeszhető // elfogadom, vagy módosítom/ellenörzés
    Modification: 500, // módosítás alatt, pickedqty szerkeszthető (internal esetén) // origin storeorder completed notification stockoperation-nek, destination order esetén origin-n értesíti
    Settled: 600, // várunk a notification-re
    Revision: 700, // confirmedqty szerkeszthető checkqty nem egyezik a pickedqty akkor állunk meg// origin order destination-t értesíti, destination order a stockoperation complete notification-t hívja
    Completed: 800,
    DeleteInitiated: 900,
    Deleted: 990,
};

export const stateTypes = {};
Object.keys(stateConst).forEach((key) => {
    stateTypes[key] = (state, operator) => operation(state, stateConst[key], operator)
});

const sortable = true;
const filterable = true;

const findMenuItem = (find, items) => {
    return items.map((item) => {
        if (item.token === find) {
            return item;
        } else if(item.items) {
            return findMenuItem(find, item.items);
        } else {
            return null;
        }
    }).find((item) => !!item);
}

class ClientPickerComponent extends React.Component {

    state = {
        opened: false,
        type: "purchase",
        filtered: true,
        confirmOperationListUpdate: false,
        confirmStoreOrderReplace: false
    };

    updateOperationList = async () => {
        if (!this.state.confirmOperationListUpdate) {
            this.setState({confirmOperationListUpdate: true});
            return;
        }
        await this.props.processAction(async () => {
            await postData({
                action: "OperationList.update",
                data: {
                    id: this.state[this.state.type].id,
                    storeorder: this.props.values[this.props.componentConfig.idfield]
                }
            });
            this.props.setContent(this.state.type, {id: this.state[this.state.type].id});
        });
    }

    createNewOperationList = async () => {
        const response = await this.props.processAction(async () => {
            const response = await postData({
                action: "OperationList.create",
                preset: this.state.type,
                data: {
                    storeorder: this.props.values[this.props.componentConfig.idfield]
                }
            });
            this.props.setContent(this.state.type, {id: response.data.id});
        });
    }

    replaceStoreOrder = async () => {
        if (!this.state.confirmStoreOrderReplace) {
            this.setState({confirmStoreOrderReplace: true});
            return;
        }
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.componentConfig.componentname + ".replace",
                [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield],
                client_component: this.state.type,
                client_component_id: this.state[this.state.type].id
            });
            this.props.setContent(response.client_component, {[response.client_component_idfield]: response.client_component_id});
        });
    }

    render() {
        if(this.props.values.client_component) {
            return null;
        }
        return (
            <Fragment>
                <Portal>
                    <Modal
                        state={this.state.confirmStoreOrderReplace}
                        size="small"
                        header="Biztos?"
                        buttons={[
                            {
                                text: "Mégse",
                                props: {color: "default", disabled: this.props.isLoading},
                                onClose: true,
                                onClick: async () => {
                                    this.setState({confirmStoreOrderReplace: false});
                                }
                            },
                            {
                                text: "Igen",
                                props: {color: "warning", disabled: this.props.isLoading || !this.state[this.state.type]},
                                onClick: async () => {
                                    await this.replaceStoreOrder();
                                }
                            }
                        ]}
                    >
                        Biztos hozzárendeled a raktári rendelést?
                    </Modal>
                </Portal>
                <Portal>
                    <Modal
                        state={this.state.confirmOperationListUpdate}
                        size="small"
                        header="Biztos?"
                        buttons={[
                            {
                                text: "Mégse",
                                props: {color: "default", disabled: this.props.isLoading},
                                onClose: true,
                                onClick: async () => {
                                    this.setState({confirmOperationListUpdate: false});
                                }
                            },
                            {
                                text: "Mehet",
                                props: {color: "warning", disabled: this.props.isLoading || !this.state[this.state.type]},
                                onClick: async () => {
                                    await this.updateOperationList();
                                }
                            }
                        ]}
                    >
                        A(z) "{(findMenuItem(this.state.type, this.props.menu.items) || {}).label}" lista elemei le lesznek cserélve a raktári rendelés tételeire!
                    </Modal>
                </Portal>
                <Portal>
                    <Modal
                        state={this.state.opened}
                        size="large"
                        header="Kiválasztás"
                        buttons={[
                            {
                                text: "Mégse",
                                props: {color: "default", disabled: this.props.isLoading},
                                onClose: true,
                                onClick: async () => {
                                    this.setState({opened: false});
                                }
                            },
                            {
                                text: this.state[this.state.type] ? "Mehet" : (UnknownStoreOrderOperationPresets.indexOf(this.state.type) !== -1 ? "Új" : "Mehet"),
                                props: {color: "primary", disabled: this.props.isLoading || (UnknownStoreOrderOperationPresets.indexOf(this.state.type) !== -1 ? false : !this.state[this.state.type])},
                                onClick: async () => {
                                    if (UnknownStoreOrderOperationPresets.indexOf(this.state.type) !== -1) {
                                        if (this.state[this.state.type]) {
                                            await this.updateOperationList();
                                        } else {
                                            await this.createNewOperationList();
                                        }
                                    } else {
                                        await this.replaceStoreOrder();
                                    }
                                }
                            }
                        ]}
                    >
                        <Tabs
                            theme="default"
                            currentTab={this.state.type}
                            onTabChange={(type) => this.setState({type})}
                        >
                            <TabContent
                                tabLabel="Tranzakció"
                                tabName="purchase"
                            >
                                <ComponentConfig componentName="purchase">
                                    <PurchaseList
                                        selection={this.state[this.state.type]}
                                        loadForm={(data) => this.setState({[this.state.type]: data})}
                                        filter={[
                                            {
                                                filters: [
                                                    [
                                                        {field: "state", value: PurchaseStates.DestinationStoreOrderSent},
                                                        {field: "customer", value: this.props.till.pos.partner.partner_id}
                                                    ],
                                                    [
                                                        {field: "state", value: PurchaseStates.OriginStoreOrderReversalSent},
                                                        {field: "seller", value: this.props.till.pos.partner.partner_id}
                                                    ]
                                                ],
                                                operator: "or"
                                            }
                                        ]}
                                    />
                                </ComponentConfig>
                            </TabContent>
                            <TabContent
                                tabLabel="Szállítás"
                                tabName="stocktransfer"
                            >
                                <ComponentConfig componentName="stocktransfer">
                                    <StockTransferList
                                        selection={this.state[this.state.type]}
                                        loadForm={(data) => this.setState({[this.state.type]: data})}
                                        filter={[
                                            {
                                                filters: [
                                                    [
                                                        {field: "state", value: StockTransferStates.DestinationStoreOrderSent},
                                                        {field: "consignee", value: this.props.till.pos.partner.partner_id}
                                                    ],
                                                    [
                                                        {field: "state", value: StockTransferStates.OriginStoreOrderReversalSent},
                                                        {field: "consignor", value: this.props.till.pos.partner.partner_id}
                                                    ]
                                                ],
                                                operator: "or"
                                            }

                                        ]}
                                    />
                                </ComponentConfig>
                            </TabContent>
                            {UnknownStoreOrderOperationPresets.map((type, idx) => {
                                const menu = findMenuItem(type, this.props.menu.items);
                                if (menu) {
                                    return <TabContent
                                        key={idx}
                                        tabLabel={menu.label}
                                        tabName={type}
                                    >
                                        <SelectorGrid
                                            selection={this.state[this.state.type]}
                                            onSelectionChange={({value}) => this.setState({[this.state.type]: value})}
                                            component="OperationList"
                                            columns={{
                                                "label": {
                                                    header: 'Címke',
                                                    width: 3,
                                                    sortable,
                                                    filterable
                                                },
                                                "partner": {
                                                    header: "Partner",
                                                    width: 2,
                                                    sortable,
                                                    filterable,
                                                    renderer: UserFormatter
                                                },
                                                "created_by": {
                                                    header: "Létrehozta",
                                                    width: 2,
                                                    renderer: UpdatedByFormatter
                                                },
                                                "created_at": {
                                                    header: "Létrehozás időpontja",
                                                    width: 2
                                                }
                                            }}
                                            filter={[
                                                {column: "preset", value: type},
                                                {column: "saved", value: 1},
                                                ...(this.state.filtered ? [{field: "created_by", value: this.props.user.id}] : [])
                                            ]}
                                            paginatorRight={(props) => <Tooltip title={!this.state.filtered ? "Csak az enyémeket mutasd" : "Mindent mutat"}><CheckBox
                                                onIcon={{lib: "fa", name: "box"}}
                                                offIcon={{lib: "fa", name: "box-open"}}
                                                value={1}
                                                checked={this.state.filtered}
                                                label={false}
                                                saveChanges={(field, value) => {
                                                    this.setState({filtered: !!value});
                                                }}
                                                {...props}
                                            /></Tooltip>}
                                        />
                                    </TabContent>;
                                }
                            })}
                        </Tabs>
                    </Modal>
                </Portal>
                {this.props.values[this.props.componentConfig.idfield] && !this.props.values.client_component && <Button
                    type="button"
                    disabled={this.props.isLoading}
                    color="primary"
                    className={"pull-right"}
                    onClick={() => this.setState({opened: true})}
                >
                    Hozzárendelés
                </Button>}
            </Fragment>
        );
    }
}

const ClientPicker = connect((state) => {
    return {
        till: state.app.till,
        user: state.app.user,
        menu: state.app.template.menu
    }
})(ClientPickerComponent);

class LinkedStoreDetailsButton extends React.Component {

    state = {
        externalOrder: null,
        url: null
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.values.store.id !== this.props.values.store.id) {
            this.loadSettings();
        }
    }

    componentDidMount() {
        this.loadSettings();
    }

    getHostAdmin = (url) => {
        switch (parse_url(url).host) {
            case "pagony.hu":
            case "www.pagony.hu":
                return url.replace("/api", "/admin/#");
            case "kiadoiadmin.pagony.hu":
            case "www.kiadoiadmin.pagony.hu":
                return url.replace("/api", "/#");
            default:
                return url.replace("/api", "/#");
        }
    }

    loadSettings = () => {
        this.loadRequest && this.loadRequest.abort();
        this.setState({
            serviceSettings: null
        }, () => {
            this.loadRequest = loadComponent("ServiceSetting", {
                filter: [
                    fieldFilter("service", "linked_store"),
                    fieldFilter("component", "store"),
                    fieldFilter("component_id", this.props.values.store.id),
                    fieldFilter("server_type", "production"),
                ]
            });
            this.loadRequest.then((serviceSettings) => {
                try {
                    serviceSettings.settings = JSON.parse(serviceSettings.settings);
                } catch (e) {

                }
                let params = {};
                if (this.props.values.external_id) {
                    params = {
                        option: "storeorder",
                        id: this.props.values.external_id,
                        view: ["client_component", "client_component_id"],
                        resptype: "jsonp"
                    };
                } else {
                    params = {
                        option: "storeorder",
                        filter: {field: "external_id", value: this.props.values[this.props.componentConfig.idfield]},
                        view: ["client_component", "client_component_id"],
                        resptype: "jsonp"
                    };
                }
                this.loadRequest = sendRequest(params, {url: serviceSettings.settings.api_url});
                this.loadRequest.then((externalOrder) => {
                    this.setState({
                        externalOrder,
                        url: this.getHostAdmin(serviceSettings.settings.api_url) + "?option=" + (componentEditors[externalOrder.client_component] || externalOrder.client_component) + "&id=" + externalOrder.client_component_id
                    });
                });
            });
        });
    }

    render() {
        if (this.state.externalOrder === null) {
            return null;
        }
        let children = this.props.children;
        let tooltip = null;
        if (!children) {
            children = <Fragment>{this.state.externalOrder.client_component_id} {ComponentFormatter({component: this.state.externalOrder.client_component, def: this.state.externalOrder.client_component})} adatai</Fragment>;
            tooltip = parse_url(this.state.url).host;
        }
        return (
            <Button
                color="default"
                icon={{lib: "fas", name: "share"}}
                tooltip={tooltip}
                onClick={() => {
                    window.open(this.state.url, '_blank');
                }}
            >
                {children}
            </Button>
        );
    }
}

export class StoreOrderEditorComponent extends React.Component {

    state = {
        diff: null,
        closeOrder: false,
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (prevProps.values[this.props.componentConfig.idfield] !== this.props.values[this.props.componentConfig.idfield]) {
            this.setState({diff: null, closeOrder: false});
        }
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    internalstoreActions = async (action) => {
        const values = this.props.values;
        await this.props.processAction(async () => {
            const response = await postData({
                action: 'internal_store.' + action,
                id: values[this.props.componentConfig.idfield]
            });
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
            }
            return response;
        });
    }

    providerActions = async (action) => {
        const values = this.props.values;
        let res = null;
        await this.props.processAction(async () => {
            res = await postData({
                action: values.serviceprovider_type + '.' + action,
                orderid: values[this.props.componentConfig.idfield]
            });
            return res;
        });
        return res;
    }

    storeorderActions = async (action, params = {}) => {
        await this.props.processAction(async ({componentAction}) => await componentAction(action, params));
    }

    getFieldProps = (name) => {
        let props = {...this.props.getFieldProps(name)};
        props = {...props};
        props.disabled = props.disabled || ["internal_store", "external_store", "production_store"].indexOf(this.props.values.serviceprovider_type) === -1;
        return props;
    }

    closeOrderAction = async () => {
        if (this.state.diff !== null) {
            if (this.state.diff) {
                if (this.state.closeOrder) {
                    try {
                        await this.storeorderActions('proceedState');
                        this.setState({closeOrder: false});
                    } catch (e) {
                        this.setState({closeOrder: false});
                        throw e;
                    }
                } else {
                    this.setState({closeOrder: true});
                }
            } else {
                await this.storeorderActions('proceedState');
            }
        }
    }

    render() {
        const clientFields = this.props.in === undefined && this.props.out === undefined && this.props.values.client_component && (!this.props.client || !(this.props.client && this.props.client.values[this.props.client.componentConfig.idfield] + "" === "" + this.props.values.client_component_id));
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        const Other = this.props.other || Fragment;
        const props = {...this.props};
        let saveButton = null;
        props.listFilter = list(props.listFilter);
        if (props.in) {
            props.listFilter.push({
                field: "ordertype",
                value: 1
            });
        } else if (props.out) {
            props.listFilter.push({
                field: "ordertype",
                value: 0
            });
        } else if (props.unknown) {
            props.listFilter.push({
                field: "client_component",
                operator: "isnull"
            });
        }
        const actionButtons = [];
        if (stateTypes.Completed(props.values.state)) {
            actionButtons.push(
                <PrintButton
                    key="1"
                    {...props}
                    className="pull-right"
                />
            );
        }
        if (
            props.values.ordertype !== undefined
            &&
            props.values.serviceprovider_type === "internal_store"
        ) {
            if (stateTypes.Reserved(props.values.state)) {
                actionButtons.push(
                    <Button
                        key="3"
                        type="button"
                        disabled={props.isLoading || this.state.diff === null}
                        color="primary"
                        className={"pull-right"}
                        onClick={this.closeOrderAction}
                    >
                        {orderTypes.SALES_ORDER(props.values.ordertype) ? "Kiszedve" : "Bevételezve"}
                    </Button>
                );
                actionButtons.push(
                    <Button
                        key="4"
                        privileges={["storeorder_bulkaccept"]}
                        type="button"
                        disabled={props.isLoading}
                        color="default"
                        className={"pull-right"}
                        onClick={() => this.internalstoreActions('bulkAccept')}
                    >
                        {orderTypes.SALES_ORDER(props.values.ordertype) ? "Összes kiszedve" : "Összes bevételezve"}
                    </Button>
                );
            }
        }
        if (this.props.values.serviceprovider_type === "linked_store") {
            actionButtons.push(
                <LinkedStoreDetailsButton
                    key="1000"
                    {...this.props}
                />
            );
        }
        if (this.props.values.serviceprovider_type === "order_delete_store" && this.props.values.external_id) {
            actionButtons.push(
                <DetailsButton
                    key="1001"
                    component_type="StockTransfer"
                    component_id={this.props.values.external_id}
                />
            );
        }
        if (
            (
                this.props.values.serviceprovider_type === "booklog_store"
                ||
                this.props.values.serviceprovider_type === "pharmalog_store"
            )
            &&
            stateTypes.Reserved(this.props.values.state)
        ) {
            actionButtons.push(
                <Button
                    key="6"
                    type="button"
                    disabled={props.isLoading}
                    color="default"
                    className={"pull-right"}
                    onClick={async () => {
                        const res = await this.providerActions('getOrderStatus');
                        this.props.showModal({
                            size: "small",
                            theme: "default",
                            header: "Státusz",
                            text: res.status
                        });
                    }}
                >
                    Állapot lekérdezés
                </Button>
            );
        }
        if (stateTypes.Processed(this.props.values.state) && orderTypes.SALES_ORDER(props.values.ordertype)) {
            actionButtons.push(<Button
                key="9"
                type="button"
                disabled={this.props.isLoading || this.state.disabled}
                color="primary"
                className={"pull-right"}
                onClick={() => this.storeorderActions('proceedState')}
            >
                Elfogadom
            </Button>);
            actionButtons.push(<Button
                key="10"
                type="button"
                disabled={this.props.isLoading || this.state.disabled}
                color="warning"
                className={"pull-right"}
                onClick={() => this.storeorderActions('redoPickup')}
            >
                Módosítom
            </Button>);
        }
        if (
            (stateTypes.Revision(this.props.values.state) && ["internal_store", "external_store", "production_store"].indexOf(this.props.values.serviceprovider_type) !== -1)
            ||
            (stateTypes.Modification(this.props.values.state) && ["external_store"].indexOf(this.props.values.serviceprovider_type) !== -1)
        ) {
            actionButtons.push(<Button
                key="11"
                type="button"
                disabled={this.props.isLoading || this.state.disabled}
                color="primary"
                className={"pull-right"}
                onClick={() => this.storeorderActions('proceedState')}
            >
                Mehet
            </Button>);
        }
        if (["external_store", "production_store"].indexOf(this.props.values.serviceprovider_type) !== -1) {
            saveButton = <Button
                key="7"
                type="button"
                disabled={!props.dirty || props.isLoading}
                color="primary"
                className={"pull-right"}
                onClick={this.props.saveForm}
            >
                Mentés
            </Button>;
        }
        actionButtons.push(
            <ClientPicker
                key="8"
                {...props}
            />
        )
        return (
            <Fragment>
                <List
                    {...props}
                    theme="default"
                    header={
                        props.componentEditor === "storeorderIn" || props.in
                            ?
                            "Bevételezés rendelések"
                            :
                            (props.componentEditor === "storeorderOut" || props.out
                                    ?
                                    "Kiszedés rendelések"
                                    :
                                    (props.componentEditor === "UnknownStoreOrder" || props.unknown
                                            ?
                                            "Ismeretlen bevétek"
                                            :
                                            "Raktári rendelések"
                                    )
                            )
                    }
                >
                    <StoreOrderList
                        ref={(el) => this.list = el}
                        {...props}
                        stateConst={stateConst}
                        stateTypes={stateTypes}
                        orderTypes={orderTypes}
                        clientFields={clientFields}
                        loadForm={this.loadForm}
                    />
                </List>
                <Editor
                    {...props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={"Raktári rendelés adatai"}
                    footer={actionButtons}
                >
                    <StoreOrderForm
                        ref={(form) => this.form = form}
                        {...props}
                        saveButton={saveButton}
                        clientFields={clientFields}
                        orderTypes={orderTypes}
                        stateTypes={stateTypes}
                        closeOrderAction={this.closeOrderAction}
                        cancelCloseOrderAction={() => this.setState({closeOrder: false})}
                        closeOrder={this.state.closeOrder}
                        diff={this.state.diff}
                        setDiff={(diff) => this.setState({diff})}
                        getFieldProps={this.getFieldProps}
                    />
                </Editor>
            </Fragment>
        );
    }
}

const StoreOrderEditor = connect(() => {},{showModal})(createEditor({
    componentName: "storeorder",
    WrappedComponent: StoreOrderEditorComponent,
    props: {
        view: "admin",
        componentActions: (action, data, params) => {
            data = {...data};
            delete data.client;
            return {action,data,params};
        }
    }
}));

export const StoreOrderClaims = connect((state) => {
    return {
        till: state.app.till
    };
},{showModal})((props) => {
    if (!(props.till && props.till.pos && props.till.pos.location && props.till.pos.location.id)) {
        return <Box header="Hiba" theme="danger">
            Kérlek jelentkezz be egy eladási helyre!
        </Box>;
    }
    props = {...props};
    props.listFilter = list(
        props.listFilter,
        fieldFilter("store", props.till.pos.location.id),
        {
            filters: [
                {filters: [fieldFilter("state", stateConst.Settled),fieldFilter("ordertype", 1)]},
                fieldFilter("state", [stateConst.Revision, stateConst.Processed, stateConst.Modification], "in"),
            ],
            operator: "OR"
        }
    );
    return <StoreOrderEditor {...props} editorContext="StoreOrderClaims" claim={true} />;
});

export default StoreOrderEditor;

const defaultState = {
    items: [],
    opened: false,
    accept: false,
    filtered: false,
    existsIds: null
};

export class StoreOrderClaim extends React.Component {

    state = defaultState

    accept = async () => {
        if (!this.state.accept) {
            this.setState({accept: true});
            return;
        }
        await this.props.processAction(async ({componentAction}) => await componentAction("claim", {items: this.state.items.map((item) => ({product_id: item.product_id, qty: item.qty}))}));
        this.setState(JSON.parse(JSON.stringify(defaultState)));
    };

    onItemUpdate = (item) => {
        let items = JSON.parse(JSON.stringify(this.state.items));
        const index = items.findIndex((i) => i.product_id + "" === "" + item.product_id);
        const qty = parseFloat(item.reserved || "0");
        if (qty + "" === "" + item.qty) {
            if (index !== -1) {
                items.splice(index, 1);
            }
        } else {
            if (index !== -1) {
                items[index].qty = qty;
            } else {
                item.qty = qty;
                items.push(item);
            }
        }
        items = items.filter((item) => parseFloat(item.qty) >= 0);
        this.setState({items});
        return true;
    }

    addPickedItem = async (product) => {
        product.product_id = product.id;
        product.reserved = product.qty;
        product.qty = 0;
        this.onItemUpdate(product);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.componentConfig.componentname !== this.props.componentConfig.componentname || prevProps.values[prevProps.componentConfig.idfield] !== this.props.values[this.props.componentConfig.idfield]) {
            this.setState({
                existsIds: null,
                items: []
            })
        }
    }

    render() {
        const items = JSON.parse(JSON.stringify(this.state.items));
        return (
            <Fragment>
                <Portal>
                    <Modal
                        state={this.state.opened}
                        theme="default"
                        size="large"
                        header="Reklamáció"
                        buttons={[
                            {
                                text: 'Mégse',
                                props: {color: "default", disabled: this.props.disabled || this.props.isLoading},
                                onClose: true,
                                onClick: async () => {
                                    try {
                                        this.setState({opened: false});
                                    } catch (e) {

                                    }
                                }
                            },
                            {
                                text: 'Mehet',
                                props: {color: "danger", disabled: this.props.disabled || this.props.isLoading || !items.length},
                                onClick: async () => {
                                    await this.accept();
                                }
                            }
                        ]}
                    >
                        <div className="form-group">
                            <ProductPicker
                                props={{getFieldProps: this.props.getFieldProps}}
                                addPickedItem={this.addPickedItem}
                                async={true}
                            />
                        </div>
                        <div className="form-group">
                            <label className="control-label">Termékek</label>
                            <SelectorGrid
                                {...this.props.getFieldProps("items")}
                                exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel"}]}
                                view={["id", "name", "qty", "unit", "listprice", "sku", "product_id"]}
                                paginatorRight={(props) => <Tooltip title={!this.props.filtered ? "Csak a reklamáltak mutatása" : "Mindent mutat"}><CheckBox
                                    {...props}
                                    onIcon={{lib: "fa", name: "box"}}
                                    offIcon={{lib: "fa", name: "box-open"}}
                                    value={this.state.filtered}
                                    label={false}
                                    saveChanges={(field, value) => {
                                        this.setState({filtered: !!value});
                                    }}
                                /></Tooltip>}
                                onLoadCompleted={(response) => {
                                    if (this.state.existsIds === null) {
                                        this.setState({existsIds: ((response.aggregations[0] || {}).product_ids || "").split(",")});
                                    }
                                }}
                                filter={this.state.filtered ? [{field: "product_id", value: items.length ? items.map((item) => item.product_id) : [0], operator: "in"}] : []}
                                aggregations={{
                                    fields: {
                                        "qty": {
                                            field: "qty", type: "SUM"
                                        },
                                        "listprice": {
                                            field: "listprice", type: "SUM"
                                        },
                                        "product_ids": {
                                            field: "product_id", type: "GROUP_CONCAT"
                                        }
                                    }
                                }}
                                columns={{
                                    "displayname": {
                                        ...ProductColumn("product_id"),
                                    },
                                    "category.name": {
                                        header: 'Árutípus',
                                        width: 1,
                                        sortable,
                                        filterable
                                    },
                                    "sku": {
                                        header: 'ISBN',
                                        sortable,
                                        filterable
                                    },
                                    "listprice": {
                                        header: 'Fogyasztói ár',
                                        sortable,
                                        filterable,
                                        renderer: CurrencyFormatter,
                                        className: "currency"
                                    },
                                    "qty": {
                                        header: 'Mennyiség',
                                        sortable,
                                        filterable,
                                        renderer: (value, row) => UnitFormatter(value, row.unit),
                                        className: "unit",
                                    },
                                    "reserved": {
                                        header: 'Visszaigazolva',
                                        sortable,
                                        renderer: (value, row) => UnitFormatter((() => {
                                            const item = (items.find((item) => item.product_id + "" === "" + row.product_id) || {});
                                            if (item.qty !== undefined) {
                                                return item.qty;
                                            }
                                            return row.qty;
                                        })(), row.unit),
                                        className: "unit",
                                        editor:
                                            (parent) =>
                                                (props, value) =>
                                                    <TextInput type="number" name="qty" label={false} focus value={(() => {
                                                        const item = (items.find((item) => item.product_id + "" === "" + props.rowData.product_id) || {});
                                                        if (item.qty !== undefined) {
                                                            return item.qty;
                                                        }
                                                        return props.rowData.qty;
                                                    })()}
                                                               onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange(props, value, {ignoreEqual: true});}}
                                                               onBlur={(e, field, value) => parent.onEditorValueChange(props, value, {ignoreEqual: true})}/>,
                                    }
                                }}
                                onItemUpdate={this.onItemUpdate}
                                onSort={(field, direction) => {
                                    if (field === "reserved" && !!items.length) {
                                        return {
                                            expression: "FIELD({{product_id}}, " + items.sort((a, b) => a.qty - b.qty).reduce((items, item) => [...items, item.product_id], []).join(", ") + ")",
                                            direction
                                        };
                                    }
                                }}
                                listfield="items"
                                data={this.props.values}
                                orderBy={{field: "name", direction: "ASC"}}
                                componentConfig={this.props.componentConfig}
                            />
                        </div>
                        <div className="form-group">
                            <label className="control-label">Új termékek</label>
                            <SelectorGrid
                                {...this.props.getFieldProps("items")}
                                columns={{
                                    "displayname": {
                                        ...ProductColumn("product_id"),
                                        sortable: false,
                                        filterable: false
                                    },
                                    "sku": {
                                        header: 'ISBN',
                                    },
                                    "listprice": {
                                        header: 'Fogyasztói ár',
                                        renderer: CurrencyFormatter,
                                        className: "currency"
                                    },
                                    "reserved": {
                                        header: 'Darabszám',
                                        renderer: (value, row) => UnitFormatter((() => {
                                            const item = (items.find((item) => item.product_id + "" === "" + row.product_id) || {});
                                            if (item.qty !== undefined) {
                                                return item.qty;
                                            }
                                            return row.qty;
                                        })(), row.unit),
                                        className: "unit",
                                        editor:
                                            (parent) =>
                                                (props, value) =>
                                                    <TextInput type="number" name="qty" label={false} focus value={(() => {
                                                        const item = (items.find((item) => item.product_id + "" === "" + props.rowData.product_id) || {});
                                                        if (item.qty !== undefined) {
                                                            return item.qty;
                                                        }
                                                        return props.rowData.qty;
                                                    })()}
                                                               onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange(props, value, {ignoreEqual: true});}}
                                                               onBlur={(e, field, value) => parent.onEditorValueChange(props, value, {ignoreEqual: true})}/>,
                                    },
                                    "qty": {
                                        header: ' ',
                                        width: 'cell-button',
                                        className: "nowrap",
                                        renderer: (value, rowData) => {
                                            return <Confirm
                                                onAccept={() => {
                                                    rowData.reserved = -1;
                                                    this.onItemUpdate(rowData);
                                                }}
                                                color="danger"
                                                icon={{lib: "fa", name: "trash"}}
                                                className="btn-xs"
                                                header="Törlés"
                                                body="Biztosan törlöd ezt a tételt?"
                                                acceptButton="Törlés"
                                            />;
                                        }
                                    }
                                }}
                                onItemUpdate={(item) => {
                                    if (item.reserved <= 0) {
                                        item.reserved = -1;
                                    }
                                    this.onItemUpdate(item);
                                }}
                                listfield="items"
                                value={items.filter((item) => (this.state.existsIds || []).indexOf(item.product_id + "") === -1)}
                                data={this.props.values}
                                componentConfig={this.props.componentConfig}
                            />
                        </div>
                    </Modal>
                    <Modal
                        state={this.state.accept}
                        theme="default"
                        header="Biztos?"
                        buttons={[
                            {
                                text: 'Mégse',
                                props: {color: "default", disabled: this.props.disabled || this.props.isLoading},
                                onClose: true,
                                onClick: async () => {
                                    try {
                                        this.setState({accept: false});
                                    } catch (e) {

                                    }
                                }
                            },
                            {
                                text: 'Mehet',
                                props: {color: "danger", disabled: this.props.disabled || this.props.isLoading},
                                onClick: async () => {
                                    await this.accept();
                                }
                            }
                        ]}
                    >
                        Biztos elindítod a reklamációt?
                    </Modal>
                </Portal>
                <Button
                    disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                    color="danger"
                    className="pull-right"
                    onClick={() => this.setState({opened: true})}
                >
                    Reklamáció
                </Button>
            </Fragment>
        );
    }
}
